/**
 * Аварийные службы — копия legacy main_services.tpl:
 * название (h3), комментарий, «Телефон:» + номер в inline-block div, <hr> между записями.
 *
 * Поля содержат HTML (ссылки на сайты служб) и выводятся как HTML — как в шаблоне.
 * Шаблон дополнительно заменял '\r' на <br> в комментарии — сохранено (withBreaks).
 */

import { Fragment } from 'react'

import { useApi } from '@/lib/useApi'

/** Строка таблицы services. */
interface Service {
  id: number
  name: string | null
  comment: string | null
  phone: string | null
}

/** Шаблон: {$service.comment|replace:'\r':'<br>'} */
function withBreaks(value: string): string {
  return value.replace(/\r/g, '<br>')
}

export function ServicesPage() {
  const { data } = useApi<Service[]>('/api/content/services')
  const services = data ?? []

  return (
    <div>
      {services.map((service, index) => {
        const comment = service.comment ?? ''
        const phone = service.phone ?? ''

        return (
          <Fragment key={service.id}>
            <h3 dangerouslySetInnerHTML={{ __html: service.name ?? '' }} />
            {comment !== '' && (
              <>
                <span dangerouslySetInnerHTML={{ __html: withBreaks(comment) }} />
                <br />
              </>
            )}
            {phone !== '' && (
              <>
                <strong>Телефон:</strong>{' '}
                <div
                  style={{ display: 'inline-block', verticalAlign: 'top' }}
                  dangerouslySetInnerHTML={{ __html: phone }}
                />
                <br />
              </>
            )}
            {index < services.length - 1 && <hr />}
          </Fragment>
        )
      })}
    </div>
  )
}
